export default __webpack_public_path__ + "static/media/img5_s.6d91aa94.png";